module.exports = __webpack_public_path__ + "4fd638a635e1b6cbd62a64fc717694fa.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Rubik/Rubik-LightItalic.ttf
// module id = 1263
// module chunks = 0